// components/admin/countries/CountryForm.jsx
import React, { useEffect, useState } from 'react';
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import toast from "react-hot-toast";
const API = process.env.REACT_APP_API_BASE;

export default function CountryForm({ editCountry, onClose, onReload }) {
  const [formData, setFormData] = useState({
    name: '',
    isoCode: '',
    currency: '',
    dateFormat: '',
    defaultLanguage: '',
    stripePublicKey: '',
    stripeSecretKey: '',
    stripeWebhookSecret: '',
    isDefault: false,
    status: true
  });

  useEffect(() => {
    if (editCountry) setFormData(editCountry);
  }, [editCountry]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = editCountry ? 'PUT' : 'POST';
    console.log(editCountry);
    const url = editCountry ? `${API}/api/countries/${editCountry._id}` : `${API}/api/countries`;

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const updatedCountries = await res.json();

      if (res.ok) {
        toast.success(`Country ${editCountry ? 'updated' : 'created'} successfully`);
        onReload(updatedCountries);
        onClose();
      } else {
        toast.error(updatedCountries.error || 'Failed to save');
      }
    } catch (err) {
      toast.error('Server error');
    }
  };

  return (
    <form className="p-6 space-y-4" onSubmit={handleSubmit}>
      <Input name="name" value={formData.name} onChange={handleChange} placeholder="Country Name" required />
      <Input name="isoCode" value={formData.isoCode} onChange={handleChange} placeholder="ISO Code (e.g., IN)" required maxLength={2} />
      <Input name="currency" value={formData.currency} onChange={handleChange} placeholder="Currency (e.g., INR)" required maxLength={3} />
      <Input name="dateFormat" value={formData.dateFormat} onChange={handleChange} placeholder="Date Format (e.g., DD/MM/YYYY)" />
      <Input name="defaultLanguage" value={formData.defaultLanguage} onChange={handleChange} placeholder="Default Language (e.g., en, hi)" />
      <Input name="stripePublicKey" value={formData.stripePublicKey} onChange={handleChange} placeholder="Stripe Public Key" required />
      <Input name="stripeSecretKey" value={formData.stripeSecretKey} onChange={handleChange} placeholder="Stripe Secret Key" required />
      <Input name="stripeWebhookSecret" value={formData.stripeWebhookSecret} onChange={handleChange} placeholder="Stripe Webhook Secret" />
      <div className="flex items-center justify-between">
        <label>Default Country</label>
        <Switch checked={formData.isDefault} onCheckedChange={(val) => setFormData(prev => ({ ...prev, isDefault: val }))} />
      </div>
      <div className="flex items-center justify-between">
        <label>Status</label>
        <Switch checked={formData.status} onCheckedChange={(val) => setFormData(prev => ({ ...prev, status: val }))} />
      </div>
      <Button type="submit" className="w-full">{editCountry ? 'Update' : 'Create'} Country</Button>
    </form>
  );
}
